<br>
<div class="row">
    <div class="col-sm-4">
        <div style="text-align: right;">
            <button *ngIf="WriteCompliance" mat-raised-button color="primary" (click)="add()">
             Add
            </button>
        </div>
        <table mat-table matSort matSortActive="sportSeason" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
            <ng-container matColumnDef="sportType">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header> Sport </th>
                <td mat-cell *matCellDef="let element">
                    {{element.sportType}}
                </td>
            </ng-container>
            <ng-container matColumnDef="sportSeason">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header> Season </th>
                <td mat-cell *matCellDef="let element">
                    {{element.sportSeason}}
                </td>
            </ng-container>
            <ng-container matColumnDef="isPrimarySport">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header> Primary Sport </th>
                <td mat-cell *matCellDef="let element">
                    {{element.isPrimarySport? 'Yes':'No'}}
                </td>
            </ng-container>           
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr matRipple mat-row [ngClass]="{'row_select': row.id === this.sportSeason.studentInstitutionSeasonId }" *matRowDef="let row; columns: displayedColumns;" (click)="edit(row.id)"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
    <div class="col-sm-8" *ngIf="isShown"  [ngClass]="{disabledDiv: !WriteCompliance}">
        <div [formGroup]="sportSeasonFormGroup">
            <div style="text-align: right;" *ngIf="WriteCompliance">
                <button  mat-raised-button color="primary" [disabled]="!sportSeasonFormGroup.valid" (click)="onSubmit()">
                    {{this.sportSeason && this.sportSeason.studentInstitutionSeasonId !== null ? 'Update': 'Save'}}
                </button>
                &nbsp;
                <button mat-raised-button (click)="cancel()" >
                    Cancel
                </button>
                &nbsp;
                <button color="warn"  *ngIf="this.sportSeason && this.sportSeason.studentInstitutionSeasonId !== null" (click)="delete(this.sportSeason.studentInstitutionSeasonId)"  mat-raised-button (click)="cancel()">
                    Delete
                </button>
            </div>
            <br>
            <mat-divider></mat-divider>
            <br>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="studentId">
                    </mat-form-field>
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="tenantId">
                    </mat-form-field>
                    <mat-form-field [hidden]="true">
                        <input matInput formControlName="studentInstitutionSeasonId">
                    </mat-form-field>

                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Sport</mat-label>
                        <mat-select required formControlName="sportTypeId">
                            <mat-option>--SELECT--</mat-option>                          
                            <ng-container *ngFor="let item of sportTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.sportTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Season</mat-label>
                        <mat-select required formControlName="sportSeasonId">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of sportSeasonList">
                                <mat-option *ngIf="evalBind(item,sportSeason.sportSeasonId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Fall Eligibility</mat-label>
                        <mat-select formControlName="fallEligibilityTypeId" [disabled]="!WriteEligibilityFields"
                        (selectionChange)="changeFallEligibilityValue($event)">
                            <mat-option>--Select--</mat-option>
                            <ng-container *ngFor="let item of sportEligibilityList">
                                <mat-option *ngIf="evalBind(item,sportSeason.fallEligibilityTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column;" dateFormat1>
                        <mat-label>Fall Eligibility Date</mat-label>
                        <input matInput formControlName="fallEligibilityDate" [disabled]="!WriteEligibilityFields" [matDatepicker]="picker1">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #picker1></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Participation</mat-label>
                        <mat-select formControlName="participationTypeId"
                            (selectionChange)="onSelectParticipationChange($event)">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of sportParticipationList">
                                <mat-option *ngIf="evalBind(item,sportSeason.participationTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Spring Eligibility</mat-label>
                        <mat-select formControlName="springEligibilityTypeId" [disabled]="!WriteEligibilityFields"
                        (selectionChange)="changeSpringEligibilityValue($event)">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of sportEligibilityList">
                                <mat-option *ngIf="evalBind(item,sportSeason.springEligibilityTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column;" dateFormat1>
                        <mat-label>Spring Eligibility Date</mat-label>
                        <input matInput formControlName="springEligibilityDate" [disabled]="!WriteEligibilityFields" [matDatepicker]="picker2">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Red Shirt</mat-label>
                        <mat-select formControlName="redShirtTypeId">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of redShirtTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.redShirtTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>F/T/R</mat-label>
                        <mat-select required formControlName="enrollmentTypeId"
                            (selectionChange)="onSelectEnrollmentChange($event)">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of studentEnrollmentTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.enrollmentTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>P/Q/N</mat-label>
                        <mat-select formControlName="freshmanQualifierTypeId">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of ftrs">
                                <mat-option *ngIf="evalBind(item,sportSeason.freshmanQualifierTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Legislation</mat-label>
                        <input matInput placeholder="Legislation" maxlength="50" formControlName="ncaalegislationCode">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-checkbox formControlName="isPrimarySport" style="margin-top: 25px;width: 50%;">Primary Sport
                    </mat-checkbox>
                </div>
                <div class="col-sm-4">
                    <mat-checkbox formControlName="isMedicalHardship" #chkHardship style="margin-top: 25px;width: 50%;">Hardship
                    </mat-checkbox>
                </div>
                <div class="col-sm-4">
                    <mat-checkbox formControlName="isNinthSemester" style="margin-top: 25px;width: 50%;">9th Semester
                    </mat-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column;" dateFormat1>
                        <mat-label>Quit Team</mat-label>
                        <input matInput formControlName="quitTeamDate" [matDatepicker]="picker3">
                        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #picker3></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Financial Aid Counter <span *ngIf="fadRequired"></span></mat-label>
                        <mat-select formControlName="financialAidAwardTypeId"
                            (selectionChange)="onSelectFadCounterChange($event)">
                            <mat-option>--Select--</mat-option>
                            <ng-container *ngFor="let item of financialAidAwardTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.financialAidAwardTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Exempt Reason <span *ngIf="reasonRequired"></span></mat-label>
                        <mat-select formControlName="financialAidAwardExemptionTypeId">
                            <mat-option>--SELECT--</mat-option>                         
                            <ng-container *ngFor="let item of financialAidAwardExemptionTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.financialAidAwardExemptionTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Term Exhausted Eligibility</mat-label>
                        <mat-select formControlName="exhaustedEligibilityTermId" [disabled]="chkHardship.checked">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of institutionTermList">
                                <mat-option *ngIf="evalBind(item,sportSeason.exhaustedEligibilityTermId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Fall Renewed Aid</mat-label>
                        <mat-select formControlName="fallAthleticFinancialAidRenewalTypeId">
                            <mat-option>--Select--</mat-option>                           
                            <ng-container *ngFor="let item of athleticFinancialAidRenewalTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.fallAthleticFinancialAidRenewalTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column;" dateFormat1>
                        <mat-label>Fall Renewed Aid Date</mat-label>
                        <input matInput formControlName="fallAthleticFinancialAidRenewalDate" [matDatepicker]="picker5">
                        <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #picker5></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Spring Renewed Aid</mat-label>
                        <mat-select formControlName="springAthleticFinancialAidRenewalTypeId">
                            <mat-option>--Select--</mat-option>                          
                            <ng-container *ngFor="let item of athleticFinancialAidRenewalTypeList">
                                <mat-option *ngIf="evalBind(item,sportSeason.springAthleticFinancialAidRenewalTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                    <mat-form-field style="display:flex;flex-direction: column;" dateFormat1>
                        <mat-label>Spring Renewed Date</mat-label>
                        <input matInput formControlName="springAthleticFinancialAidRenewalDate"
                            [matDatepicker]="picker6">
                        <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #picker6></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-4">
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>Squad List Comment</mat-label>
                        <textarea matInput placeholder="Squad List Comment" maxlength="250" rows="4"
                            formControlName="squadComment"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="WriteCompliance" style="text-align: right;">
                <button  mat-raised-button color="primary" [disabled]="!sportSeasonFormGroup.valid" (click)="onSubmit()">
                    {{this.sportSeason && this.sportSeason.studentInstitutionSeasonId !== null ? 'Update': 'Save'}}
                </button>
                &nbsp;
                <button mat-raised-button (click)="cancel()" >
                    Cancel
                </button>               
            </div>
        </div>
    </div>
</div>
